import { ErrorMessage, Field, Formik, Form } from "formik";
import Header from "../../../Navbar/Header";
import Sidebar from "../../sidebar/Sidebar";
import { useEffect, useRef, useState } from "react";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import { addCompany, deleteCompany, deletecompanyPayroll, getCompany, submitPaySlip, updateCompany } from "../hrmsSlice";
import { Button, Spinner } from "react-bootstrap";
import StyledDataTable from "../../../../component/resuable/StyledComponent";
import { toast } from "react-toastify";
import DeleteDialog from "../../../../component/resuable/deleteDialog";
import { useLocation, useNavigate } from "react-router-dom";
import RunPayroll from "./RunPayroll";
import RunPayrollModal from "./RunPayroll";
import Holiday from "./Holiday";
import ReactDatePicker from "react-datepicker";
import axios from "axios";
import { apiGet } from "../../../../service/apiService";

export default function Company() {
    const [initialValues, setInitialValues] = useState({
        company_name: '',
        pf_amount: ""
    });
    const navigate = useNavigate();
    const [commonLoad, setCommonLoad] = useState(false)
    const [showPayrollDelete, setShowPayrollDelete] = useState(false)
    const dispatch = useDispatch()
    const [rowData, setRowData] = useState([]);
    const companyData = useSelector(state => state.hrms.companyData);
    const location = useLocation();
    const [editData, setEditData] = useState("");
    const [deleteId, setDeleteId] = useState(null);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectedData, setselectedData] = useState("");
    const [showHoliday, setShowHoliday] = useState('')

    const validationSchema = Yup.object().shape({
        company_name: Yup.string().required("Company Name is required"),
        pf_amount: Yup.string().required("Provident Fund is required"),
    });
    const getPreviousMonth = () => {
        const date = new Date(); // Get the current date
        date.setMonth(date.getMonth() - 1); // Set to the previous month
        date.setDate(1); // Optional: Set to the first day of the month
        return date;
    };
    const [filterdate, setFilterdate] = useState(getPreviousMonth());

    useEffect(() => {
        if (location.pathname === "/hrms") {
            setShowHoliday(''); // Reset to table view when navigating to Resume
        }
    }, [location]);
    const [openPayroll, setOpenPayroll] = useState(false)

    const handleDeleteClick = (data) => {
        setselectedData(data.company_name)
        setDeleteId(data.company_id)
        setEditData(data);
        setShowDeleteDialog(true);
    };
    const deletePayroll = (data) => {
        setShowPayrollDelete(true)
        setDeleteId(data.payroll_id)
        setselectedData(data.company_name)
    }
    const runpayroll = () => {
        setOpenPayroll(true)
    }
    const closePayRoll = () => {
        setOpenPayroll(false)
    }
    const handleHoliday = () => {
        setShowHoliday('addHoliday')
    }
    useEffect(() => {
        if (companyData && Array.isArray(companyData.companies)) {
            const formattedData = companyData.companies.map((data) => ({
                company_name: data.company_name,
                spending_amount: data.spending_amount,
                total_amount: data.total_amount,
                company_id: data.company_id,
                download_link: data.download_link,
                payslip_shared: data.payslip_shared,
                pf_amount: data.pf_amount,
                payroll_id: data.payroll_id
            }));
            setRowData(formattedData);
        }
    }, [companyData]);
    const handleSubmit = async (values, { resetForm }) => {
        if (editData && editData.company_id) {
            const response = await dispatch(updateCompany({ ...values, company_id: editData.company_id })).unwrap();
            if (response.status === 200) {
                resetForm();
                setEditData(null);
                setInitialValues({ company_name: '', pf_amount: '' });
                toast.success('Company Updated Successfully');
            } else {
                toast.error(response?.data?.message);
            }

        } else {
            const response = await dispatch(addCompany(values)).unwrap();
            if (response.status === 201) {
                resetForm()
                toast.success('Company Added Successfully');
            } else {
                toast.error(response?.data?.message)
            }
        }
    };

    function formatDate(date) {
        if (date) {
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            return { month, year };
        }
        return { month: '', year: '' };
    }
    useEffect(() => {
        const fetchData = async () => {
            const { month, year } = filterdate ? formatDate(filterdate) : { month: '', year: '' };
            await dispatch(getCompany({
                month: month,
                year: year
            }));
        };

        fetchData();
    }, [dispatch, filterdate]);

    const handleEditClick = (data) => {
        console.log(data)
        setInitialValues({
            company_name: data.company_name,
            pf_amount: data.pf_amount

        });
        setEditData(data);
    };
    const sendPaySlip = async (data) => {
        try {
            setCommonLoad(true)
            const { month, year } = filterdate ? formatDate(filterdate) : { month: '', year: '' };
            const res = await apiGet(`send_payslip_emails?company_id=${data.company_id}&month=${month}&year=${year}`);
            if (res?.status === 200) {
                toast.success(res?.data?.message || 'Payslips sent successfully')
                const fetchRes = await dispatch(getCompany({ month, year }));
            } else {
                toast.error(res?.data?.message || 'Payslips Not Sent')
            }
        } catch (error) {
            toast.error('Payslips Not Sent')
        } finally {
            setCommonLoad(false)
        }
    }

    const handleDownloadPayslip = async (data) => {

        try {
            setCommonLoad(true)
            const { month, year } = filterdate ? formatDate(filterdate) : { month: '', year: '' };
            const res = await apiGet(`downloadpayrollzip?company_id=${data.company_id}&month=${month}&year=${year}`);
            const url = res?.data?.payslip_url;
            if (!url) {
                toast.error(res?.data?.message || 'Payslip URL not available');
                return;
            }
            window.open(url, '_blank');
            toast.success('Payslip Downloaded successfully');
        } catch (error) {
            toast.error('Payslip Not Downloaded');
        } finally {
            setCommonLoad(false)
        }

    }
    const columns = [
        {
            name: "S.No",
            selector: (row, index) => index + 1,
            width: '5%',
        },
        {
            name: 'Name',
            selector: (row) => row.company_name,
            width: '20%',
            cell: (row) => (
                <div className="text-primary cursor-pointer "  onClick={() => navigate('/hrms/employee', { state: { row, filterdate } })}>
                    {row.company_name}
                </div>
            ),
        },
        {
            name: 'Total Salary',
            selector: (row) => row.total_amount,
            width: '8%',
        },
        {
            name: 'Spend Salary',
            selector: (row) => row.spending_amount,
            width: '8%',
        },
        {
            name: 'Download ',
            selector: (row) => (
                row.download_link ? (
                    <a href={row.download_link} target="_blank" rel="noopener noreferrer">
                        Download
                    </a>
                ) : (
                    <span>Payroll not run</span>
                )
            ),
            width: '8%',
        },
        {
            name: 'Download Payslip',
            cell: (row) => (
                <>
                    {row?.download_link ? (
                        <Button variant="primary" className="table-custom-button1 px-2" onClick={() => handleDownloadPayslip(row)}>
                            Download Payslips
                        </Button>
                    ) : (
                        'Payroll not run'
                    )}
                </>
            ),
            width: '14%',
        },
        {
            name: 'Send Payslip',
            cell: (row) => (
                <>
                    {row?.download_link && (
                        row?.payslip_shared === 0 ? (
                            <Button variant="success" className="table-custom-button1 px-2" onClick={() => sendPaySlip(row)}>
                                Send Payslip
                            </Button>
                        ) : (
                            <p className="table-viewcustom-withouthover px-2">Payslip sent</p>
                        )
                    )}
                </>
            ),
            width: '12%',
        },
        // Conditional "Delete Payroll" column
        ...(rowData.some(row => row.download_link) ? [{
            name: "Delete Payroll",
            cell: (row) => (
                <>
                    {row?.download_link && (
                        <Button
                            variant="primary"
                            className="table-custom-button px-2"
                            onClick={() => deletePayroll(row)}
                            style={{ marginRight: '8px' }}
                        >
                            Delete Payroll
                        </Button>
                    )}
                </>
            ),
            button: true,
            width: '12%',
        }] : []),
        {
            name: "Action",
            cell: (row) => (
                <>
                    <Button variant="primary" className="table-custom-button1" onClick={() => handleEditClick(row)}>
                        <i className="fas fa-edit px-2"></i>
                    </Button>
                    <Button variant="danger" className="table-viewcustom-button" onClick={() => navigate('/hrms/employee', { state: { row, filterdate } })}>
                        <i className="fas fa-eye px-2"></i>
                    </Button>
                    <Button variant="primary" className="table-custom-button" onClick={() => handleDeleteClick(row)} style={{ marginRight: '8px' }}>
                        <i className="fas fa-trash px-2"></i>
                    </Button>
                </>
            ),
            button: true,
            width: '15%',
        },
    ];


    const handleDelete = async (id) => {
        const response = await dispatch(deleteCompany(id));
        if (response.payload.status === 200) {

            window.location.reload();
            toast.success("Company Data Deleted successfully");
        } else {
            toast.error(response.payload.response.data.message)
        }
    };
    const handledeletePayroll = async (id) => {
        const response = await dispatch(deletecompanyPayroll(id));
        if (response.payload.status === 200) {

            window.location.reload();
            toast.success("Company Data Deleted successfully");
        } else {
            toast.error(response.payload.response.data.message)
        }
    };

    const handleBack = () => {
        setShowHoliday('')
    }
    const renderMonthContent = (month, shortMonth, longMonth) => {
        const tooltipText = `Tooltip for month: ${longMonth}`;
        return <span title={tooltipText}>{shortMonth}</span>;
    };
    return (
        <>

            {commonLoad && (
                <div className="spinner-container"> {/* Wrap the spinner with a div */}
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>)}
            <div className='container-fluid'>
                <div className='row'>
                    <Header />
                    <div className='col-2 p-0'>
                        <Sidebar />
                    </div>
                    {showHoliday === '' && (
                        <div className='col-10 mt-2 px-3'>
                            <div className='card custom-card p-3'>
                                <h4 >Add Your Company</h4>
                                <div className='row justify-content-center'>
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={validationSchema}
                                        onSubmit={handleSubmit}
                                        enableReinitialize={true}
                                    >
                                        {({ values,
                                            setFieldValue, }) => (
                                            <Form>
                                                <div className="row">
                                                    <div className="col-md-8 px-3 py-2">



                                                        <div className="d-md-flex mr-5 gap-3">
                                                            <div>
                                                                <label className='form-label'>Company Name</label>
                                                                <Field
                                                                    type='text'
                                                                    className='form-control'
                                                                    placeholder='Enter Company Name'
                                                                    name='company_name'
                                                                />
                                                                <ErrorMessage name='company_name' component='div' className="text-danger" />
                                                            </div>
                                                            <div>
                                                                <label className='form-label'>Provident Fund</label>
                                                                <Field
                                                                    type='text'
                                                                    className='form-control'
                                                                    placeholder='Enter Provident Fund'
                                                                    name='pf_amount'
                                                                />
                                                                <ErrorMessage name='pf_amount' component='div' className="text-danger" />
                                                            </div>
                                                            <div className="d-flex align-items-end mt-3 mt-md-0">

                                                                <button className="btn defult-button ms-2 ms-md-0" type='submit'>Submit</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4 px-3 py-2 text-end">
                                                        <button className="btn defult-button ms-2" type="button" onClick={runpayroll}>Update Attendance</button>
                                                    </div>


                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>

                                <div className='d-flex py-2 '>
                                    <ReactDatePicker className='form-control datefilter' placeholderText='Select filter'
                                        renderMonthContent={renderMonthContent}
                                        showMonthYearPicker
                                        dateFormat="MM/yyyy"
                                        selected={filterdate}
                                        onChange={(date) => {
                                            setFilterdate(date);
                                        }}
                                    />
                                    <button className="table-viewcustom-button p-1 btn btn-primary" onClick={() => setFilterdate(null)}><i class="fa fa-retweet" aria-hidden="true"></i></button>
                                    <h4 className="text-center"></h4>
                                </div>
                                <div className="mt-2">
                                    <StyledDataTable
                                        columns={columns}
                                        data={rowData.length > 0 ? rowData : []}
                                        highlightOnHover
                                        responsive
                                        persistTableHead={true}
                                    />
                                </div>
                            </div>
                            {showDeleteDialog && deleteId && (
                                <DeleteDialog
                                    id={deleteId}
                                    data={selectedData}
                                    onDelete={handleDelete}
                                    onClose={() => setShowDeleteDialog(false)}
                                />
                            )}
                            {openPayroll && (
                                <RunPayrollModal closePayRoll={closePayRoll} onClose={() => setOpenPayroll(false)} />
                            )}
                        </div>)}

                    {/* {showHoliday === 'addHoliday' && (
                        <Holiday handleBack={handleBack} />
                    )} */}


                    {showPayrollDelete && (
                        <DeleteDialog
                            id={deleteId}
                            data={selectedData}
                            onDelete={handledeletePayroll}
                            onClose={() => setShowPayrollDelete(false)}
                        />
                    )}


                </div>
            </div>
        </>
    );
}